import { Component, input } from '@angular/core';

import { ForeignAddress } from '../foreign-address.model';

/**
 * @ngdoc component
 * @name ApReadonlyComponent
 *
 * @param {ForeignAddress} address The foreign address to display
 */
@Component({
    selector: 'ap-foreign-address-read-only',
    templateUrl: './readonly.component.html'
})
export class ApReadonlyComponent {
    /**
     * Foreign Address to show
     */
    public readonly address = input.required<ForeignAddress>();
}
